module.exports = __webpack_public_path__ + "assets/img/13.32b6f98e.png";